import { Pressable, Text, View } from 'react-native'
import { useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'

import { Icon, symbolName } from '../../../components/ui/Icon'
import { colors } from '../../../theme'
import { body1, label1 } from '../../../theme/typography'

export function SubscriptionRequiredPlaceholder() {
  const { t } = useTranslation(['purchase', 'common'])
  const { push } = useRouter()

  return (
    <View className="flex-1 justify-center items-center px-8 bg-background-primary">
      <View className="items-center mb-8">
        <View className="w-16 h-16 rounded-full bg-fill items-center justify-center mb-4">
          <Icon
            name={symbolName('lock', 'lock')}
            size={32}
            color={colors.muted}
          />
        </View>
        <Text
          style={[label1, { color: colors.ink, textAlign: 'center' }]}
          className="mb-2"
        >
          {t('purchase:no_active_subscription_title')}
        </Text>
        <Text
          style={[body1, { color: colors.inkSecondary, textAlign: 'center' }]}
        >
          {t('purchase:no_active_subscription_message')}
        </Text>
      </View>

      <Pressable
        className="rounded-xl py-3 px-8 items-center w-full max-w-[300px]"
        style={{ backgroundColor: colors.primary }}
        onPress={() => push('/purchase')}
      >
        <Text style={[label1, { color: colors.primaryForeground }]}>
          {t('purchase:subscribe_cta')}
        </Text>
      </Pressable>
    </View>
  )
}
